// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RROf","col":"styles_col__1uIrN","actions":"styles_actions__YmyUX","conflict":"styles_conflict__39tHt"};